
interface JobsNavProps {
  scrolled: boolean;
}

export default function JobsNav({ scrolled }: JobsNavProps) {
  const deepLink = 'https://onnyjob.onelink.me/z1EO/ussr8zbl?deep_link_value=eyJhZ2VuY3kiOiJBRzAyMjUyNjAwNTEifQ==';
  
  const menuItems = [
    { label: '채용정보', path: deepLink },
    { label: '인재찾기', path: deepLink },
    { label: '커뮤니티', path: deepLink },
    { label: '기업서비스', path: deepLink },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-dark-deep/95 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-dark-deep/80 backdrop-blur-sm'
      }`}
    >
      <div className="px-10 py-5 flex items-center justify-between">
        {/* Logo */}
        <a
          href={deepLink}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/9b5ff483-3eed-4f76-9321-1639ea9d593d.png"
            alt="온니잡 Logo"
            className="h-10 w-auto"
          />
          <span className="text-2xl font-bold text-white">온니잡</span>
        </a>

        {/* Center Menu */}
        <div className="flex items-center gap-14">
          {menuItems.map((item) => (
            <a
              key={item.label}
              href={item.path}
              className="text-base font-medium relative group transition-colors whitespace-nowrap cursor-pointer text-white hover:text-neon-purple"
            >
              {item.label}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-neon-purple group-hover:w-full transition-all duration-300"></span>
            </a>
          ))}
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-4">
          <a
            href={deepLink}
            className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-400 hover:border-neon-purple hover:text-neon-purple transition-all cursor-pointer"
          >
            <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href={deepLink}
            className="px-7 py-3 rounded-full border border-white/20 text-white hover:border-neon-purple hover:text-neon-purple transition-all whitespace-nowrap cursor-pointer"
          >
            로그인
          </a>
          <a
            href={deepLink}
            className="px-7 py-3 rounded-full bg-gradient-neon text-white shadow-neon-purple hover:shadow-[0_0_30px_rgba(168,85,247,0.7)] transition-all whitespace-nowrap cursor-pointer"
          >
            회원가입
          </a>
        </div>
      </div>
    </nav>
  );
}
